import { render, staticRenderFns } from "./CrewList.vue?vue&type=template&id=a82523d8"
import script from "./CrewList.vue?vue&type=script&lang=js"
export * from "./CrewList.vue?vue&type=script&lang=js"
import style0 from "./CrewList.vue?vue&type=style&index=0&id=a82523d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports